export default {"src":"/_next/static/media/trinidad-and-tobago.5fd461b1.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};